import { useAuth0 } from '@auth0/auth0-react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { AuthService } from '../api/auth-service';
import type { CurrentUser } from '../types/auth';

export const currentUserQueryKeys = {
  all: ['current-user'] as const,
};

/** `GET /auth/me` — the signed-in user's Bagel record, including their role. */
export function useCurrentUser(): UseQueryResult<CurrentUser> {
  const { isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: currentUserQueryKeys.all,
    queryFn: AuthService.getCurrentUser,
    enabled: isAuthenticated,
    staleTime: 5 * 60 * 1000,
    retry: (failureCount, error) => {
      // 401/404 are terminal: the token carries no identity, or the user is not
      // provisioned. Retrying either just delays the unauthorized screen.
      const status = authErrorStatus(error);
      if (status === 401 || status === 404) return false;
      return failureCount < 2;
    },
  });
}

export function authErrorStatus(error: unknown): number | undefined {
  return axios.isAxiosError(error) ? error.response?.status : undefined;
}
